import { EDateSelectionType } from "../../../models"

export interface ICustomReportDocument {
    Id: string
    AccountId: string
    Name: string
    Type: ECustomReportType
    
    // it's valid for NewCustomReportType
    Location: ECustomReportLocation
    // it's valid for NewCustomReportType
    DateSelectionType: EDateSelectionType

    CSharpScript: string
    DefaultFileName: string
    FileExtension: string
    ContentDisposition?: string
    Deleted?: boolean
    Version: number
}

export enum ECustomReportType {
    PayrollTimeExport,
    PayrollExpenseExport,
    TimecardPunchDetailReport,
    TimecardSummaryReport,
    TimecardAuditReport,
    TimecardEstimatedTimeReport,
    TimecardInOutReport,
    NewCustomReportType,
    ScheduleReport,
    TimecardValidationScript,
    TimeoffExport,
    PayrollPPAExport,
}

export enum ECustomReportLocation {
    None,
    TimecardTab,
    EmployeePage,
    EmployeeTimecardTab,
}